// @ts-nocheck

import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'

export class AccessRestriction extends Component<any, any> {
  render() {
    const { children, restricted, role } = this.props

    if (restricted === role || restricted.includes(role)) {
      return null
    }
    return children
  }
}

AccessRestriction.propTypes = {
  children: PropTypes.node.isRequired,
  restricted: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  role: PropTypes.string
}

AccessRestriction.defaultProps = {
  restricted: 'senior-carer'
}

const mapStateToProps = (state) => {
  return {
    role: state.global.user.role
  }
}

export default connect(mapStateToProps, null)(AccessRestriction)
